import { c as _c } from "react/compiler-runtime";
import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
import { SEARCH_PARAMS, STORAGE_KEY } from '@/constants';

/** 초대 링크로 진입한 사용자가 회원가입을 할 때에 어떤 사람에게서 초대를 받았는지 식별하기 위한 memberCode를 localStorage에 저장 */
export const useStoreMemberCode = () => {
  const $ = _c(3);
  const searchParams = useSearchParams();
  let t0;
  let t1;
  if ($[0] !== searchParams) {
    t0 = () => {
      const memberCode = searchParams?.get(SEARCH_PARAMS.MEMBER_CODE);
      if (memberCode) {
        localStorage.setItem(STORAGE_KEY.MEMBER_CODE, memberCode);
      }
    };
    t1 = [searchParams];
    $[0] = searchParams;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
};